import { render } from "./PasswordReset.html?vue&type=template&id=54692501&scoped=true&ts=true&external"
import script from "./PasswordReset.vue?vue&type=script&lang=ts"
export * from "./PasswordReset.vue?vue&type=script&lang=ts"

import "./PasswordReset.scss?vue&type=style&index=0&id=54692501&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54692501"]])

export default __exports__